(function(angular){
	'use strict';

	angular
		.module('totalOriginationsChartModule')
		.directive('totalOriginationsChart', [
			'$window',
			'HIGHCHARTS_OPTIONS',
			TotalOriginationsChartFunction
		]);

	function TotalOriginationsChartFunction(
		$window,
		HIGHCHARTS_OPTIONS) {
		return {
			replace: true,
			restrict: 'E',
			scope: {
			},
			template: '<div class="aspect-ratio-4-3 aspect-ratio-16-9-md position-relative"><div id="total-originations-chart" class="coterminous"></div></div>',
			link: function($scope, $attrs, $elem) {

				Highcharts.setOptions(HIGHCHARTS_OPTIONS());
				
				var data = [{ x: '1/1/2013', y: 1875000 }, { x: '8/13/2013', y: 4275000 }, { x: '12/31/2013', y: 5940000 }, { x: '1/1/2014', y: 10140000 }, { x: '1/16/2014', y: 12140000 }, { x: '1/23/2014', y: 15640000 }, { x: '2/6/2014', y: 18040000 }, { x: '2/18/2014', y: 21277200 }, { x: '3/18/2014', y: 22612494 }, { x: '4/17/2014', y: 26612494 }, { x: '4/24/2014', y: 29133494 }, { x: '5/8/2014', y: 59576494 }, { x: '6/13/2014', y: 59576495 }, { x: '6/16/2014', y: 65236495 }, { x: '6/16/2014', y: 65536495 }, { x: '7/10/2014', y: 75229842 }, { x: '7/10/2014', y: 76429842 }, { x: '7/21/2014', y: 77929460 }, { x: '7/25/2014', y: 78979460 }, { x: '7/28/2014', y: 84267310 }, { x: '7/29/2014', y: 88560547 }, { x: '9/5/2014', y: 90762621 }, { x: '9/13/2014', y: 104581417 }, { x: '10/22/2014', y: 111610352 }, { x: '10/23/2014', y: 114424903 }, { x: '11/18/2014', y: 117534903 }, { x: '11/24/2014', y: 124581840 }, { x: '12/17/2014', y: 126460704 }, { x: '12/18/2014', y: 140218979 }, { x: '12/19/2014', y: 142153979 }, { x: '12/19/2014', y: 150747248 }, { x: '1/1/2015', y: 150747249 }, { x: '1/5/2015', y: 153430969 }, { x: '1/16/2015', y: 154897589 }, { x: '1/23/2015', y: 182881034 }, { x: '3/2/2015', y: 187060134 }, { x: '3/3/2015', y: 207935134 }, { x: '3/19/2015', y: 227935134 }, { x: '4/1/2015', y: 239310134 }, { x: '4/13/2015', y: 262960134 }, { x: '4/27/2015', y: 269327634 }, { x: '5/4/2015', y: 354125534 }, { x: '5/26/2015', y: 368325534 }, { x: '6/4/2015', y: 384368024 }, { x: '6/15/2015', y: 417568024 }, { x: '6/29/2015', y: 421705903 }, { x: '6/30/2015', y: 423175095 }, { x: '7/2/2015', y: 450963095 }, { x: '7/2/2015', y: 454206639 }, { x: '7/29/2015', y: 482904457 }, { x: '8/10/2015', y: 510504457 }, { x: '8/26/2015', y: 513729750 }, { x: '9/8/2015', y: 518979969 }, { x: '9/14/2015', y: 535744969 }, { x: '9/14/2015', y: 554094969 }, { x: '9/23/2015', y: 568078007 }, { x: '9/30/2015', y: 576932007 }, { x: '10/22/2015', y: 579223547 }, { x: '10/27/2015', y: 581831082 }, { x: '10/30/2015', y: 592312443 }, { x: '11/3/2015', y: 605071143 }, { x: '12/15/2015', y: 630102485 }, { x: '12/15/2015', y: 632587770 }, { x: '12/18/2015', y: 665647770 }, { x: '12/30/2015', y: 667077620 }, { x: '1/7/2016', y: 691704413 }, { x: '1/7/2016', y: 720624413 }, { x: '1/20/2016', y: 725052570 }, { x: '1/21/2016', y: 725052571 }, { x: '1/27/2016', y: 728583488 }, { x: '2/17/2016', y: 734626990 }, { x: '3/2/2016', y: 765726990 }, { x: '4/6/2016', y: 774626990 }, { x: '4/29/2016', y: 792001990 }, { x: '5/12/2016', y: 799968117 }, { x: '5/20/2016', y: 830962553 }, { x: '6/6/2016', y: 844162553 }, { x: '6/6/2016', y: 886862553 }, { x: '6/27/2016', y: 897927447 }, { x: '6/28/2016', y: 901207447 }, { x: '9/14/2016', y: 904046990 }, { x: '9/14/2016', y: 946394892 }, { x: '9/19/2016', y: 986394892 }, { x: '9/29/2016', y: 1009516882 }, { x: '10/15/2016', y: 1011992882 }, { x: '10/15/2016', y: 1013592882 }, { x: '10/15/2016', y: 1015167882 }, { x: '11/11/2016', y: 1016847882 }, { x: '11/11/2016', y: 1062048534 }, { x: '11/24/2016', y: 1101039534 }, { x: '11/29/2016', y: 1131096534 }, { x: '12/7/2016', y: 1145545824 }, { x: '12/30/2016', y: 1186490821 }, { x: '1/31/2017', y: 1223244227 }, { x: '2/28/2017', y: 1225444227 }, { x: '3/31/2017', y: 1255094427 }, { x: '4/30/2017', y: 1330640632 }, { x: '5/31/2017', y: 1353440552 }, { x: '6/30/2017', y: 1359777672 }, { x: '7/31/2017', y: 1367459404 }, { x: '10/31/2017', y: 1500000000 }, { x: '4/30/2018', y: 2000000000 }, { x: '8/31/2018', y: 2500000000 }];
				
				angular.forEach(data, function(point) {
					point.x = new Date(point.x);
				});
				
				var chart = new Highcharts.Chart({
					chart: {
						renderTo: 'total-originations-chart'
					},
					series: [{
						type: 'area',
						data: data,
						color: {
							linearGradient: { x1: 0, y1: 1, x2: 1, y2: 0 },
							stops: [
								[0, '#F6A01A'],
								[1, '#F47735']
							]
						},
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, Highcharts.Color('#FF6A19').setOpacity(0.5).get('rgba')],
								[1, Highcharts.Color('#F6A01A').setOpacity(0).get('rgba')]
							]
						}
					}],
					xAxis: {
						type: 'datetime'
					},
					yAxis: {
						endOnTick: false,
						labels: {
							formatter: function() {
								return '$' + Highcharts.numberFormat((this.value / 1000000), 0) + 'M';
							}
						},
						tickInterval: 250000000
					}
				});
			}
		};
	}
})(window.angular);